<template>
    <!-- Payments Requests Received -->
    <f7-list media-list v-if="inMessages" id="payments-item-received">
      <li class="swipeout"
      v-for="inMessage in filteredInMessage"
      :key="inMessage.id"
      :style="{background: getSeenStatusBackground(inMessage.isRead)}"
      @swipeout:deleted="onSwipeoutDeleted(inMessage.id)">
      	<div class="swipeout-content" @click="seeDetails(inMessage, true)"  >
      		<div class="item-content boxRequest">
      			<div class="item-media">
              <i class="icon list-icon" v-bind:class="getIcon(inMessage.status, inMessage.negotStatus)"></i>
            </div>
      			<div class="item-inner">
      				<div class="item-title-row">
                <table width="100%">
                  <tr>
                    <td class="requestTitle">
            					<div
                      :style="{fontWeight: getSeenStatusFontWeight(inMessage.isRead)}">
                        {{ inMessage.reason }}
                        <span class="showSmallScreenOnly item-subtitle">({{ inMessage.amount }} €)</span>
                        <span class="showLargeScreenOnly paperclip">
                          &nbsp;<f7-icon v-if="inMessage.attachmentId" fa="paperclip"></f7-icon>
                        </span>
                      </div>
                    </td>
                    <td class="showLargeScreenOnly" width="30%">
                      <div>{{ $t('common.total_amount_no_currency') }}: {{ inMessage.amount }} €</div>
                    </td>
                    <td width="40%">
                      <div class="showLargeScreenOnly">
                        {{ $t('common.from') + ': ' + getSenderName(inMessage)}}
                      </div>
                    </td>
                  </tr>
                </table>
    						<div class="item-after">
                  <span>{{inMessage.creationDate | formatDate}}</span>
              		<div class="swipeout-actions-right showSmallScreenOnly">
                		<a href="#" class="swipeout-delete">Delete</a>
                	</div>
                  <div class="item-media showLargeScreenOnly" v-if="canDelete()">
                    <button class="button-swipe-out event.stopPropagation()" @click="deleteOnWeb(inMessage.id, 'IN', $event)">
                      <i class="fa fa-times-circle button-delete" ></i>
                    </button>
                  </div>
      					</div>
      				</div>
              <div class="item-title-row">
                <div class="item-subtitle showSmallScreenOnly">{{'From: ' + getSenderName(inMessage)}}</div>
                <span class="statusLabel showLargeScreenOnly">{{ $t('common.status.status_label') }}: {{getStatusLabel(inMessage.status, inMessage.negotStatus, 0)}}</span>
                <div class="item-after">
                  <span class="showSmallScreenOnly"><f7-icon v-if="inMessage.attachmentId" fa="paperclip"></f7-icon></span>
                  <span class="showLargeScreenOnly"><f7-icon class="orangeFont" v-if="inMessage.reminder === '1'" fa="bell"></f7-icon></span>
                </div>
              </div>
              <div class="item-title-row showSmallScreenOnly">
                <div class="statusLabel">{{ $t('common.status.status_label') }}: {{getStatusLabel(inMessage.status, inMessage.negotStatus, 0)}}</div>
                <div class="item-after">
                  <f7-icon class="orangeFont" v-if="inMessage.reminder === '1'" fa="bell"></f7-icon>
                </div>
              </div>
      			</div>
          </div>
      	</div>
      </li>
    </f7-list>

    <!-- Payments Requests Sent -->
    <f7-list media-list v-else id="payments-item-sent">
      <li class="blackfont swipeout"
      v-for="outMessage in filteredOutMessage"
      :key="outMessage.id"
      :style="{background: getSeenStatusBackground(outMessage.isRead)}"
      @swipeout:deleted="onSwipeoutDeleted(outMessage.id)">
      	<div class="swipeout-content item-content boxRequest" @click="seeDetails(outMessage, true)">
      			<div class="item-media">
              <i class="icon list-icon" v-bind:class="getIcon(outMessage.status, outMessage.negotStatus)"></i>
            </div>
      			<div class="item-inner">
      				<div class="item-title-row">
                <table width="100%">
                  <tr>
                    <td class="requestTitle">
                      <div class="item-title"
                      :style="{fontWeight: getSeenStatusFontWeight(outMessage.isRead)}">
                        {{ outMessage.reason }}
                        <span class="showLargeScreenOnly paperclip">
                          &nbsp;<f7-icon v-if="outMessage.attachmentId" fa="paperclip"></f7-icon>
                        </span>
                      </div>
                    </td>
                    <td width="70%">
                      <div class="showLargeScreenOnly">
                        {{'To: ' + getRecipientName(outMessage)}}
                      </div>
                    </td>
                  </tr>
                </table>
    						<div class="item-after">
                  <span>{{outMessage.creationDate | formatDate}}</span>
                  <div class="swipeout-actions-right showSmallScreenOnly" v-if="canDelete()">
                    <a href="#" class="swipeout-delete">Remove</a>
                  </div>
                  <div class="item-media showLargeScreenOnly" v-if="canDelete()">
                    <button class="button-swipe-out" @click="deleteOnWeb(outMessage.id, 'OUT', $event)">
                      <i class="fa fa-times-circle button-delete" ></i>
                    </button>
                  </div>
      					</div>
      				</div>
              <div class="item-title-row">
                <div class="item-subtitle showSmallScreenOnly">{{'To: ' + getRecipientName(outMessage)}}</div>
                <span class="statusLabel showLargeScreenOnly">{{ $t('common.status.status_label') }}: {{getStatusLabel(outMessage.status, outMessage.negotStatus, 1)}}</span>
                <div class="item-after">
                  <span class="showLargeScreenOnly"><f7-icon class="orangeFont" v-if="outMessage.reminder === '1'" fa="bell"></f7-icon></span>
                  <span class="showSmallScreenOnly"><f7-icon v-if="outMessage.attachmentId" fa="paperclip"></f7-icon></span>
                </div>
              </div>
              <div class="item-title-row showSmallScreenOnly">
                <div class="statusLabel">{{ $t('common.status.status_label') }}: {{getStatusLabel(outMessage.status, outMessage.negotStatus, 1)}}</div>
                <div class="item-after">
                  <f7-icon class="orangeFont" v-if="outMessage.reminder === '1'" fa="bell"></f7-icon>
                </div>
              </div>
      			</div>
      		</div>
      </li>
    </f7-list>
</template>

<script>
import {errorMessageAlert} from '@/helpers/alert'
import {loadPage} from '@/helpers/routing'
import {statusLabel, statusIcon, statusColor, getSeenStatusBackground, getSeenStatusFontWeight} from '@/helpers/labels'
import {updateToSeen} from '@/helpers/storage'

export default {
  name: 'TransactionsList',
  props: ['inMessages', 'outMessages', 'filterBy'],
  data: () => {
    return {
      statusColor: 'blue',
      icon: 'help',
      fromIdToServiceName: {
        '1': 'payments',
        '2': 'directDebit',
        '6': 'directPayments'
      }
    }
  },
  computed: {
    filteredInMessage () {
      if (this.filterBy) {
        return this.inMessages.filter((a) => {
          return a.reason.toLowerCase().includes(this.filterBy.toLowerCase()) ||
            a.creditorName.toLowerCase().includes(this.filterBy.toLowerCase())
        })
      }
      // console.log(this.inMessages)
      return this.inMessages
    },
    filteredOutMessage () {
      if (this.filterBy) {
        return this.outMessages.filter((a) => {
          return a.reason.toLowerCase().includes(this.filterBy.toLowerCase()) ||
            a.debtorName.toLowerCase().includes(this.filterBy.toLowerCase())
        })
      }
      // console.log(this.outMessages)
      return this.outMessages
    }
  },
  methods: {
    deleteOnWeb (payId, listType, e) {
      e.stopPropagation()
      let that = this
      this.$f7.modal({
        title: this.$t('common.rm_label') + ' ?',
        text: this.$t('received.no_more_see'),
        buttons: [
          {
            text: 'Cancel',
            color: 'red',
            onClick: function () {
            }
          },
          {
            text: 'Yes',
            onClick: function () {
              var list
              if (listType === 'IN') {
                list = that.filteredInMessage
              } else {
                list = that.filteredOutMessage
              }

              var idPaymentInList = -1
              for (var i = 0; i < list.length; i++) {
                if (list[i].id === payId) {
                  idPaymentInList = i
                  break
                }
              }
              list.splice(idPaymentInList, 1)
              that.deletePayments(payId)
            }
          }
        ]
      })
    },
    onSwipeoutDeleted (payId) {
      this.deletePayments(payId)
    },
    deletePayments (payId) {
      let that = this
      that.$engine.services[this.fromIdToServiceName[this.$engine.user.currentService.id]].delete(payId)
        .then(response => {
          if (response.status === 200) {
          }
        })
        .catch(error => {
          that.$f7.hidePreloader()
          errorMessageAlert(error, that)
        })
    },
    getIcon (status, negotStatus) {
      return statusIcon(status, negotStatus)
    },
    getStatusLabel (status, negotStatus, direction) {
      return statusLabel(this.$i18n, status, negotStatus, direction)
    },
    getColor (status, negotStatus) {
      return statusColor(status, negotStatus)
    },
    seeDetails (message, isReceived) {
      if (this.$engine.user.currentService.id === '1') {
        this.$engine.settings.set({clickedMessage: message})
        this.$engine.settings.set({msgFromInbox: isReceived})
      }
      let that = this
      if (message.direction === '0') {
        if (this.$engine.user.currentService.id === '2') {
          that.$engine.services.directDebit.currentInbox = message
        }
        if (this.$engine.user.currentService.id === '6') {
          that.$engine.services.directPayments.currentInbox = message
        }
      } else {
        if (this.$engine.user.currentService.id === '2') {
          that.$engine.services.directDebit.currentSendbox = message
        }
        if (this.$engine.user.currentService.id === '6') {
          that.$engine.services.directPayments.currentSendbox = message
        }
      }
      let redirectionUrl = {
        '1': '/payments/transaction-details/',
        '2': '/directDebit/details/',
        '6': '/directPayments/details/'
      }
      loadPage(that, {url: redirectionUrl[this.$engine.user.currentService.id] + message.direction + '/'})
      if (message.isRead !== '1') {
        this.updateToSeen(message.id)
      }
    },
    updateToSeen (payId) {
      let that = this
      let found = false
      for (let i in this.inMessages) {
        if (this.inMessages[i].id === payId) {
          this.inMessages[i].isRead = '1'
          found = true
        }
      }
      if (!found) {
        for (let i in this.outMessages) {
          if (this.outMessages[i].id === payId) {
            this.outMessages[i].isRead = '1'
          }
        }
      }

      updateToSeen(that, payId, that.fromIdToServiceName[this.$engine.user.currentService.id])
    },
    getSeenStatusBackground (isRead) {
      return getSeenStatusBackground(isRead)
    },
    getSeenStatusFontWeight (isRead) {
      return getSeenStatusFontWeight(isRead)
    },
    canDelete () {
      let that = this
      // Tous les comptes particuliers peuvent supprimer une demande
      if (that.$engine.user.get().type === '2') {
        return true
      }
      for (var i = 0; i < that.$settings.currentAccount.userAccts.length; i++) {
        if (that.$settings.currentAccount.userAccts[i].id === that.$engine.user.userAccountId) {
          if (that.$engine.user.get().type === '1' && that.$settings.currentAccount.userAccts[i]['Payments'] === '1') {
            return true
          }
        }
      }
      return false
    },
    getSenderName (message) {
      if (this.$engine.user.currentService.id === '6') {
        return message.debtorName
      }
      return message.creditorName
    },
    getRecipientName (message) {
      if (this.$engine.user.currentService.id === '6') {
        return message.creditorName
      }
      return message.debtorName
    }
  }
}
</script>



// WEBPACK FOOTER //
// TransactionsList.vue?4f4793b8